/**
 * What the CRM tells the request logs about each GraphQL request, so a slow
 * request can be traced to its operation and screen.
 *
 * - The page: `x-ra-page`, the route only, with record ids as `:id`
 *   (`/leads/:id`). Never the query string: list pages keep what a user typed
 *   into search (names, emails, phone numbers) there. The hasura worker logs
 *   it. A header name joins the CORS preflight once; its value can change
 *   freely without a new preflight.
 * - The operation, for hasura-scrapers only: `?op=<operationName>` on the URL.
 *   The CRM calls hasura-scrapers without a worker, and Cloud Run's request
 *   log never sees the body or the headers. The hasura worker reads the
 *   operation from the body, so hasura-crm keeps one URL. A URL per operation
 *   costs one CORS preflight per operation every 2 hours (Chrome's preflight
 *   cache cap); hasura-scrapers serves about 20 operations. Hasura ignores
 *   the query string (checked on v2.8.4 and v2.48.9).
 */
export const PAGE_HEADER = 'x-ra-page';

const UUID = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi;
const NUMERIC_SEGMENT = /\/\d+(?=\/|$)/g;
const MAX_PAGE_LENGTH = 200;

export const pageRoute = (pathname: string): string =>
  pathname
    .replace(UUID, ':id')
    .replace(NUMERIC_SEGMENT, '/:id')
    .slice(0, MAX_PAGE_LENGTH);

export const operationTaggedUri = (
  endpoint: string,
  operationName: string | null | undefined,
): string =>
  operationName != null && /^[_A-Za-z][_0-9A-Za-z]*$/.test(operationName)
    ? `${endpoint}?op=${operationName}`
    : endpoint;
